export const IGNORED_CLIENT_ERROR_CODES = [400, 401, 403, 404, 409, 422];
